<template>
    <div class="row gx-3">
        <pc-label
            v-bind:label="label"
            v-bind:for-id="inputId"
            v-bind:show-required="required"
            v-bind:show-help="showHelp"
            v-bind:help-link="showHelpLinkOnly"
            class="col-12"
            v-on:help-clicked="emitHelpClicked" />
        <div class="col-12">
            <slot name="help" />
        </div>
        <div class="col-12">
            <div class="row g-0 mt-2 overflow-auto">
                <div v-bind:class="responsiveClasses.leftLabel">
                    <pc-label
                        v-bind:label="leftLabel"
                        v-bind:for-id="inputId" />
                </div>
                <div v-bind:class="responsiveClasses.tileGroup">
                    <div ref="scale">
                        <pc-tile-group
                            v-bind="binder"
                            id="options"
                            outline
                            v-bind:label="label"
                            v-bind:options="options"
                            data-test-role="radiobuttonlist-element"
                            v-on="listeners"
                            v-on:help-clicked="emitHelpClicked" />
                    </div>
                </div>
                <validation-render-helper v-bind:validation-error="validationError" />
                <div v-bind:class="responsiveClasses.rightLabel">
                    <pc-label
                        class="text-end"
                        v-bind:label="rightLabel"
                        v-bind:for-id="inputId" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import base, { validationRenderHelper } from "./_elementBase";
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        leftLabel: {
            col: { md: "auto" },
            mt: { xs: 2, md: 0 },
            me: { xs: 0, md: 3 },
            order: { xs: 2, md: 1 },
            always: "col d-flex align-items-center"
        },
        rightLabel: {
            col: { md: "auto" },
            mt: { xs: 2, md: 0 },
            ms: { xs: 0, md: 3 },
            always: "col order-last d-flex align-items-center justify-content-end"
        },
        tileGroup: {
            col: { xs: 12, md: "auto" },
            order: { xs: 1, md: 2 }
        }
    };

    export default {
        components: { validationRenderHelper },
        extends: base,
        data() {
            return {};
        },
        computed: {
            leftLabel() {
                return this.element.Properties.leftlabel;
            },
            rightLabel() {
                return this.element.Properties.rightlabel;
            },
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            },
            options() {
                // need to convert to int here to account for cases going from single digits to double digits
                // string comparison besides 0 or 1 such as Start: 9 End: 11.
                const start = parseInt(this.element.Properties.startvalue);
                const end = parseInt(this.element.Properties.endvalue);
                const options = [];

                // start and end should be >= 0
                if (start < 0 || end < 0) {
                    return [];
                }

                // start and end should be <= 100
                if (start > 100 || end > 100) {
                    return [];
                }

                // total number of options should not exceed 11
                if (Math.abs(end - start) > 10) {
                    return [];
                }

                // total number of options should be at least 2
                if (Math.abs(end - start) < 1) {
                    return [];
                }

                let index = 0;
                if (start < end) {
                    for (let i = start; i <= end; i++) {
                        options[index] = { value: i, text: +i };
                        index++;
                    }
                } else {
                    for (let i = start; i >= end; i--) {
                        options[index] = { value: i, text: +i };
                        index++;
                    }
                }
                return options;
            }
        }
    };
</script>
